import { TrendTutorialExampleProps } from '@/components/Crash/TrendTutorialModal/Content/Example/props';
import { CrashTrenballColor } from '@/models/crash/trenball/color';

export const trenballExamples: TrendTutorialExampleProps[] = [
  {
    data: [
      [
        CrashTrenballColor.Green,
        CrashTrenballColor.Green,
        CrashTrenballColor.Green,
        null,
        null,
        null,
      ],
      [CrashTrenballColor.Orange, null, null, null, null, null],
      [
        CrashTrenballColor.Green,
        CrashTrenballColor.Yellow,
        null,
        null,
        null,
        null,
      ],
      [null, null, null, null, null, null],
      [null, null, null, null, null, null],
      [null, null, null, null, null, null],
    ],
    multipliers: [
      {
        color: CrashTrenballColor.Green,
        value: 5.64,
      },
      {
        color: CrashTrenballColor.Green,
        value: 2.63,
      },
      {
        color: CrashTrenballColor.Green,
        value: 4.15,
      },
      {
        color: CrashTrenballColor.Orange,
        value: 1.82,
      },
      {
        color: CrashTrenballColor.Green,
        value: 2.31,
      },
      {
        color: CrashTrenballColor.Yellow,
        value: 18.78,
      },
    ],
  },
  {
    data: [
      [
        CrashTrenballColor.Green,
        CrashTrenballColor.Yellow,
        CrashTrenballColor.Green,
        CrashTrenballColor.Green,
        CrashTrenballColor.Green,
        CrashTrenballColor.Green,
      ],
      [
        CrashTrenballColor.Orange,
        CrashTrenballColor.Orange,
        null,
        null,
        null,
        null,
      ],
      [CrashTrenballColor.Green, null, null, null, null, null],
      [null, null, null, null, null, null],
      [null, null, null, null, null, null],
      [null, null, null, null, null, null],
    ],
    multipliers: [
      {
        color: CrashTrenballColor.Green,
        value: 2.25,
      },
      {
        color: CrashTrenballColor.Yellow,
        value: 18.12,
      },
      {
        color: CrashTrenballColor.Green,
        value: 4.21,
      },
      {
        color: CrashTrenballColor.Green,
        value: 3.24,
      },
      {
        color: CrashTrenballColor.Green,
        value: 2.14,
      },
      {
        color: CrashTrenballColor.Green,
        value: 3.31,
      },
      {
        color: CrashTrenballColor.Orange,
        value: 1.32,
      },
      {
        color: CrashTrenballColor.Orange,
        value: 1.96,
      },
      {
        color: CrashTrenballColor.Green,
        value: 4.46,
      },
    ],
  },
];
